import moment from 'moment';
import { IconNames } from 'sharedComponents/core/Icon';

type ActivityType =
  | 'completedCourse'
  | 'newCourse'
  | 'activated'
  | 'failedCourse';

export const activityTitle = (
  firstName: string,
  activityType: ActivityType,
  courseName?: string,
  classroomInstance?: {
    endDate: string;
    startDate: string;
  }
) => {
  var nameMap = {
    completedCourse: 'Completed',
    newCourse: 'Has been booked on',
    activated: 'Account was created',
    failedCourse: 'Failed'
  };

  var iconMap: { [key: string]: IconNames } = {
    completedCourse: 'CourseStatus_Completed',
    newCourse: 'CourseNewCourseGreen',
    activated: 'CourseStatus_NotStarted',
    failedCourse: 'CourseFailed'
  };

  var iconTextMap = {
    completedCourse: 'Completed Course',
    newCourse: 'Started Course',
    activated: 'Account Activated',
    failedCourse: 'Failed course'
  };
  let title = courseName
    ? `${firstName} ${nameMap[activityType]} the ${courseName} Course`
    : nameMap[activityType];
  if (classroomInstance) {
    title = `${title} on ${moment(
      activityType === 'completedCourse' || activityType === 'failedCourse'
        ? classroomInstance.endDate
        : classroomInstance.startDate
    ).format('LL')}`;
  }

  return {
    title,
    icon: iconMap[activityType],
    iconText: iconTextMap[activityType]
  };
};
